import { env } from '../env';

// Create a custom fetch wrapper with default configuration
const fetchInstance = async (url, options = {}) => {
    const token = window.sessionStorage.getItem('token');
    const subVenueId = window.sessionStorage.getItem('subVenueId');
    
    // Add token and subVenueId to headers
    let headers = {};

    if (subVenueId) {
        headers['subVenueId'] = subVenueId;
    }

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    // Merge default headers with provided options
    const config = {
        ...options,
        headers: {
            ...headers,
            ...options.headers
        }
    };
    
    try {
        const response = await fetch(`${env.API_BASE_URL}${url}`, config);
        
        // Handle common error cases
        if (!response.ok) {
            switch (response.status) {
                case 401:
                    // Handle unauthorized
                    window.sessionStorage.removeItem('token');
                    window.location.href = '/login';
                    break;
                case 403:
                    // Handle forbidden
                    break;
                default:
                    break;
            }
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
};

export default fetchInstance; 


// WEBPACK FOOTER //
// ./src/api/fetchConfig.js